import { Injectable } from '@angular/core';
import { appServerResources } from '../app server constants';
import { Observable } from 'rxjs';
import { BasehttpService } from './basehttp.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(public httpServiceProvider: BasehttpService) { }

  getAllOnlineCity(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getCityByPropertyId/" + propertyId;
    return this.httpServiceProvider.get(url)
  }

  getAreaByPropertyId(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAreaByPropertyId/" + propertyId;
    return this.httpServiceProvider.get(url)
  }

  getAreaByCityId(cityId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAreaByCityId/" + cityId;
    return this.httpServiceProvider.get(url)
  }

  getAllBusinessByName(search, propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllBusinessByName/" + search + "/" + propertyId;
    return this.httpServiceProvider.get(url)
  }

  // Dedicated API for loading all businesses for a property (no city/area filter)
  getAllBusinessByPropertyIdForWebsite(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllBusinessByPropertyIdForWebsite/" + propertyId;
    return this.httpServiceProvider.get(url)
  }
  getAllBusinessByAccountId(isReservation) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllBusinessByAccountId/" + isReservation;
    return this.httpServiceProvider.get(url)
  }

  getOrderTrackByUserId(userId) {
    let url = appServerResources.SERVER_PATH + "LocationsService" + appServerResources.VERSION + "/CustomerService/getOrderTrackByUserId/" + userId;
    console.log(url);
    return this.httpServiceProvider.get(url)
  }

  getAllCountries() {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getAllCountries";
    return this.httpServiceProvider.get(url)
  }

  getPropertyById(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getPropertyById/" + propertyId;   
     return this.httpServiceProvider.get(url)
  }
  getUrlParam(paramName) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getUrlParam/" + paramName;
    return this.httpServiceProvider.get(url)
  }

  getAllGlobalCusineTypes(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllGlobalCusineTypeByPropertyId/" + propertyId;
    return this.httpServiceProvider.get(url)
  }

  getAllGlobalItemTypes(propertyId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllGlobalItemsTypeByPropertyId/" + propertyId;
    return this.httpServiceProvider.get(url)
  }

  getAllBusinessByCityIdItemsTypeIdCuisineTypeId(cityId, itemsTypeId, cusineId, proprtyId, forceAreaLookup: boolean = false) {

    let url;
    let geo = JSON.parse(localStorage.getItem("Geolocation"));
    if(geo && !forceAreaLookup)
    {
      url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getBusinessByLongitudeLattituteNative/" + geo.longitude + "/" + geo.latitude + "/" + proprtyId;
    }else
    {
      url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getAllBusinessByAreaIdItemsTypeIdCuisineTypeIdNative/" + cityId + "/" + itemsTypeId + "/" + cusineId + "/" + proprtyId;
                                                                                                                      
    }
    
    return this.httpServiceProvider.get(url)
  }

  getCityById(cityId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getCityById/" + cityId;
    return this.httpServiceProvider.get(url)
  }

  getReferenceNumberByAccountIdAndBusinessIdForWebsite(accountId, businessId) {
    let url = appServerResources.SERVER_PATH + "PartnerManagementService" + appServerResources.VERSION + "/CustomerService/getReferenceNumberByAccountIdAndBusinessIdForWebsite/" + accountId + "/" + businessId;
    return this.httpServiceProvider.get(url)
  }

  getLocationsByBusinessId(businessId) {
    let url = appServerResources.SERVER_PATH + "LocationsService" + appServerResources.VERSION + "/CustomerService/getLocationsByBusinessId/" + businessId;
    return this.httpServiceProvider.get(url)
  }

  getAllDataByBusinessId(businessId) {
    let url = appServerResources.SERVER_PATH + "LocationsService" + appServerResources.VERSION + "/CustomerService/getAllDataByBusinessId/" + businessId;
    return this.httpServiceProvider.get(url)
  }

  getBusiness(businessId) {
    let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getBusiness/" + businessId;
    console.log(url);
    return this.httpServiceProvider.get(url)
  }

  getAllStatesByCountryId(countryId) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getAllStatesByCountryId/" + countryId;
    return this.httpServiceProvider.get(url)
  }

  getAllCityByStateId(stateId) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getAllCityByStateId/" + stateId;
    return this.httpServiceProvider.get(url)
  }

  getDeliveryRuleByLocationId(locationId) {
    let url = appServerResources.SERVER_PATH + "LocationsService" + appServerResources.VERSION + "/CustomerService/deliveryRule/" + locationId;
    return this.httpServiceProvider.get(url)
  }

  // /deliveryRulesToDistanceUnit/{distance}/{deliveryRuleId}")
  getDeliveryChargeByDistanceAndRuleId(distance,ruleId) {
    let url = appServerResources.SERVER_PATH + "LocationsService" + appServerResources.VERSION + "/CustomerService/deliveryRulesToDistanceUnit/" + distance + "/" + ruleId;
    return this.httpServiceProvider.get(url)
  }

  // /getDeliveryQuote/{isTest}/{locationId}/{name}/{pickup_lat}/{pickup_lng}/{drop_lat}/{drop_lng}/{category_id}
  getDeliveryChargeByDunzoApi(isTest,locationId,name,orderid,pickup_lat,pickup_lng,drop_lat,drop_lng,category_id) {
    let url = appServerResources.SERVER_PATH + "OrderManagementService" + appServerResources.VERSION + "/CustomerService/getDeliveryQuote/" + isTest + "/" + locationId+ "/" + name+ "/" + orderid+ "/"+ pickup_lat+ "/" + pickup_lng+ "/" + drop_lat+ "/" + drop_lng+ "/" + category_id;
    return this.httpServiceProvider.get(url)
  }

  getDeliveryPartnerById(deliveryPartnerId) {
    let url = appServerResources.SERVER_PATH + "OrderManagementService" + appServerResources.VERSION + "/CustomerService/getDeliveryPartnerById/" + deliveryPartnerId;
    return this.httpServiceProvider.get(url)
  }

  // /createTask/{isTest}/{locationId}/{name}/{orderId}

  createDunzoTask(isTest,locationId,name,orderId,dunzoPacket){
    let url = appServerResources.SERVER_PATH + "OrderManagementService" + appServerResources.VERSION + "/CustomerService/createTask/"+isTest+"/"+locationId+"/"+name+"/"+orderId;
    return this.httpServiceProvider.post(url,dunzoPacket);
  }

  getBuildVersion() {
      let url = appServerResources.SERVER_PATH + "GlobalBusinessService" + appServerResources.VERSION + "/CustomerService/getBuildVersionByPropertyId/" + localStorage.getItem("propertyId");
      return this.httpServiceProvider.get(url)
  }

  getDeliveryChargeForUberDirectxApi(locationId,name,orderId,postPacket) {
    let url = appServerResources.SERVER_PATH + "OrderManagementService" + appServerResources.VERSION + "/CustomerService/getDeliveryQuoteForUberDirect/" +locationId+ "/" + orderId;
    return this.httpServiceProvider.post(url,postPacket);
  }

  





}
